export const ValidationRegex = {
  get numberWithUnit() {
    return /^\d+(\.\d+)?\w+(\d+)?$/g;
  },
  get absolutePath() {
    return /^\/(\w+)?/g;
  },
  get url() {
    return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;
  },
  get video() {
    return /([a-z\-_0-9\/\:\.]*\.(ogg|mpeg|aac))/g;
  },
  get image() {
    return /\.(jpg|jpeg|png|gif)$/g;
  },
  get email() {
    return /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/g;
  },
  get validProcedure() {
    return /^\w+(_\w+)?\((\s+)?((((true|null|false|\d+|\'(.+)?\')(\s+)?\,(\s+)?)+)?((true|null|false|\d+|\'(.+)?\')(\s+)?))?\)$/g;
  },
  get phoneNumber() {
    return /^(\d{3}-){2}\d{4}$/g;
  },
  get timeSpan() {
    return /^-?(?:\d+\.)?(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d{1,7})?$/;
  },
  get templatePlaceholderRegex() {
    return /{{([\s\S]+?)}}/g;
  },
  get alphanumeric() {
    return /[^A-Za-z0-9 ]/g;
  },
  get letters() {
    return /^[A-Za-z ]+$/g;
  },
  get search() {
    return /[.*+?^${}()|[\]\\"]/g;
  },
};

export function buildOrSearchRegex(searchValue: string, regFlags: string = 'gi') {
  if (!searchValue) return null;
  const safeSearchValue = searchValue.replace(ValidationRegex.search, '\\$&');
  const pattern = safeSearchValue.replace(/,\s*/g, '|');
  return new RegExp(pattern, regFlags);
}
